import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _ExpArgumentOperandRestrictionFactory;
/* eslint-disable */
/**
 * Expression Service
 * An API for Expression services, supporting the Expression Editor and Expression Evaluation
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech) (v6.0.1).
 *
 * Do not edit the class manually.
 */

// InputSpec (yaml) file: /var/jenkins_home/workspace/V4-5-1-global-pipeline-all-web-products-build/webcommons/abweb/openapi/internal/typescript/target/openapi/openapi//abwebinternal/expressionservice.yaml
// Template file: models.mustache (typescript-fetch)

/**
 * 
 * @export
 * @interface ExpArgumentOperandRestriction
 */

export class ExpArgumentOperandRestrictionFactory {}
_ExpArgumentOperandRestrictionFactory = ExpArgumentOperandRestrictionFactory;
_defineProperty(ExpArgumentOperandRestrictionFactory, "FromJSON", function (json) {
  return _ExpArgumentOperandRestrictionFactory.FromJSONTyped(json, false);
});
_defineProperty(ExpArgumentOperandRestrictionFactory, "FromJSONTyped", function (json, ignoreDiscriminator) {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    'description': json['description'],
    'omitCategoryID': json['omitCategoryID'],
    'forValueTypeID': json['forValueTypeID']
  };
});
_defineProperty(ExpArgumentOperandRestrictionFactory, "ToJSON", function (value) {
  return _ExpArgumentOperandRestrictionFactory.ToJSONTyped(false, value);
});
_defineProperty(ExpArgumentOperandRestrictionFactory, "ToJSONTyped", function (ignoreDiscriminator, value) {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    'description': value.description,
    'omitCategoryID': value.omitCategoryID,
    'forValueTypeID': value.forValueTypeID
  };
});
//# sourceMappingURL=ExpArgumentOperandRestriction.js.map
